import React, {useEffect} from 'react';

import {LoadingSpinner} from '@albert-io/atomic';
import {useIsFeatureFlagEnabled} from 'client/components/FeatureFlag/featureFlag.utils';
import {history} from 'client/history';
import FRQViewV2 from './FreeResponseQuestionView/FRQViewV2.react';

/**
 * Feature-flag wrapper for the /free-response/:set(/:question) view route.
 * Flag ON: redirects to the guide listing. Users reach PracticeView via /learn/ links
 *   generated directly by FreeResponseQuestionGuide when usePracticeViewLinks is true.
 * Flag OFF: renders legacy FRQViewV2 (read-only sample/explanation view).
 */
const FRQViewRouter = (props) => {
  const {isFeatureEnabled, isLoading} = useIsFeatureFlagEnabled('ai_graded_frq');
  const {slug} = props.params;

  useEffect(() => {
    if (!isLoading && isFeatureEnabled) {
      history.replace(`/${slug}/free-response`);
    }
  }, [isLoading, isFeatureEnabled, slug]);

  if (isLoading || isFeatureEnabled) {
    return <LoadingSpinner />;
  }

  return <FRQViewV2 {...props} />;
};

export default FRQViewRouter;
